import PhoneButton from '@/components/base/PhoneButton';

export default function CTABanner() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Istanbul%20night%20cityscape%20aerial%20view%2C%20Bosphorus%20bridge%20lights%2C%20city%20lights%20reflection%20on%20water%2C%20dramatic%20night%20sky%2C%20beautiful%20urban%20panorama%20Turkey&width=1920&height=600&seq=cta001&orientation=landscape"
          alt="İstanbul Çilingir Hizmeti"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-flex items-center gap-2 border border-orange-400/50 text-orange-300 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
          <span className="w-2 h-2 bg-orange-400 rounded-full animate-ping"></span>
          Şu An Müsait
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
          Acil Durumda Hemen Arayın
        </h2>
        <p className="text-gray-300 text-lg mb-3">7/24 Kesintisiz Hizmet</p>
        <p className="text-gray-400 text-base mb-8">Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir'de 15 dakikada yanınızdayız</p>
        <PhoneButton size="lg" />
      </div>
    </section>
  );
}
